import { EmailTemplate } from '../../types';

enum IndPvtLtdIncorporationTaskGroups {
  COMPANY_FORMATION_DETAILS = 'COMPANY_FORMATION_DETAILS',
  NAME_RESERVATION = 'NAME_RESERVATION',
  INCORPORATION_FILING = 'INCORPORATION_FILING',
  BANK_ACCOUNT_CREATION = 'BANK_ACCOUNT_CREATION',
  ADT_1_FILING_HANDOFF = 'ADT_1_FILING_HANDOFF',
  SHARE_CERTIFICATES = 'SHARE_CERTIFICATES',
  INC_20A_FILING = 'INC_20A_FILING',
}

export enum IndPvtLtdIncorporationTasks {
  FILL_CORPORATION_DETAILS = 'FILL_CORPORATION_DETAILS',
  REVIEW_CORPORATION_DETAILS = 'REVIEW_CORPORATION_DETAILS',
  COMPLETE_MCA_NAME_RESERVATION = 'COMPLETE_MCA_NAME_RESERVATION',
  UPLOAD_DOCUMENTS_FOR_MCA_NAME_RESERVATION = 'UPLOAD_DOCUMENTS_FOR_MCA_NAME_RESERVATION',
  SEND_EMAIL_UPDATE = 'SEND_EMAIL_UPDATE',
  INCORPORATION_DOCUMENT_PREPARATION = 'INCORPORATION_DOCUMENT_PREPARATION',
  CLIENT_UPLOAD_SIGNED_DOCUMENT = 'CLIENT_UPLOAD_SIGNED_DOCUMENT',
  FILING_SUBMITTED_TO_MCA = 'FILING_SUBMITTED_TO_MCA',
  CLIENT_UPLOAD_CERT_OF_INCORP = 'CLIENT_UPLOAD_CERT_OF_INCORP',
  CLIENT_UPLOAD_PAN = 'CLIENT_UPLOAD_PAN',
  CLIENT_UPLOAD_TAN = 'CLIENT_UPLOAD_TAN',
  AGENT_UPLOAD_AOA = 'AGENT_UPLOAD_AOA',
  AGENT_UPLOAD_MOA = 'AGENT_UPLOAD_MOA',
  CLIENT_ADD_BANK_ACCOUNT = 'CLIENT_ADD_BANK_ACCOUNT',

  // ADT-1 Filing Handoff (Agent only)
  ADT_1_FILING_HANDOFF = 'ADT_1_FILING_HANDOFF',

  BCD_FILING_SUBMITTED = 'BCD_FILING_SUBMITTED', // for backwards compatibility
  UPLOAD_INC_20A = 'UPLOAD_INC_20A', // for backwards compatibility
  UPLOAD_SIGNED_FILLED_ADT_FORM = 'UPLOAD_SIGNED_FILLED_ADT_FORM', // for backwards compatibility
  UPLOAD_FILLED_ADT_FORM = 'UPLOAD_FILLED_ADT_FORM', // for backwards compatibility
  UPLOAD_CA_CERTIFICATE = 'UPLOAD_CA_CERTIFICATE', // for backwards compatibility

  // Share Certificate Issuance
  CLIENT_UPLOAD_BANK_STATEMENT_OF_SUBS_AMT = 'CLIENT_UPLOAD_BANK_STATEMENT_OF_SUBS_AMT',
  SOURCING_STAMP_PAPER = 'SOURCING_STAMP_PAPER',
  UPLOAD_ISSUE_SHARE_CERTIFICATE = 'UPLOAD_ISSUE_SHARE_CERTIFICATE',
  UPLOAD_SIGNED_SHARE_CERTIFICATE = 'UPLOAD_SIGNED_SHARE_CERTIFICATE',

  // INC-20a Filing
  CLIENT_UPLOAD_OFFICE_SPACE = 'CLIENT_UPLOAD_OFFICE_SPACE',
  CLIENT_UPLOAD_DIRECTOR_PHOTO = 'CLIENT_UPLOAD_DIRECTOR_PHOTO',
  INC_20A_FILING_SUBMITTED = 'INC_20A_FILING_SUBMITTED',
  UPLOAD_INC_20A_ACKNOWLEDGEMENT = 'UPLOAD_INC_20A_ACKNOWLEDGEMENT',
}

export const IND_PVT_LTD_TASK_GROUP_TO_EMAIL_MAP: Record<
  IndPvtLtdIncorporationTaskGroups,
  EmailTemplate | null
> = {
  [IndPvtLtdIncorporationTaskGroups.COMPANY_FORMATION_DETAILS]: null,
  [IndPvtLtdIncorporationTaskGroups.NAME_RESERVATION]: {
    body: `Hi,

Congratulations! We've received approval of your Private Limited Company name reservation from the Ministry of Corporate affairs. Your approval letter has been uploaded to the Commenda dashboard.

The team is now preparing your incorporation documents, this usually takes a day. These will need your signatures before they are filed. We will post an update once the documents are ready for your signature.

Have a wonderful day!
Team Commenda

    `,
    subject: 'Pvt Ltd Entity Name Approved',
  },
  [IndPvtLtdIncorporationTaskGroups.INCORPORATION_FILING]: {
    body: `
  Hi,
  

Congratulations! We've received notification of your Pvt Ltd Incorporation from the Ministry of Corporate Affairs. You will receive your PAN card and TAN number at the registered email address. Request you to upload your Certificate of Incorporation, Company PAN and TAN to the Commenda Dashboard. 

You can now proceed with opening your business bank account for the Pvt Ltd entity, sharing a list of partner bank contacts below. We recommend getting in touch with the partner to find a bank that best suits your business needs.

Yatin from HSBC - tel:+918588953747
Rishabh from HSBC - tel:+919019987737
Pramod from Standard Chartered - tel:+919284382240
Devansh from Standard Chartered - tel:+919833475050

Have an amazing day!
Team Commenda

    `,
    subject: 'Pvt Ltd Incorporation Approved',
  },
  [IndPvtLtdIncorporationTaskGroups.BANK_ACCOUNT_CREATION]: null,
  [IndPvtLtdIncorporationTaskGroups.ADT_1_FILING_HANDOFF]: null,
  [IndPvtLtdIncorporationTaskGroups.SHARE_CERTIFICATES]: {
    body: `
 Hi,

Your signed share certificates are now available on the Commenda dashboard. Login to download them whenever required!

Have an amazing day!
Team Commenda
    `,
    subject: 'Share Certificates uploaded',
  },
  [IndPvtLtdIncorporationTaskGroups.INC_20A_FILING]: {
    body: `
Hi,

Your INC-20A (Commencement of Business) filing has been completed successfully. The acknowledgement has been uploaded to the Commenda dashboard.

Your entity setup is now complete!

Have an amazing day!
Team Commenda

    `,
    subject: 'INC-20A Filing completed',
  },
};
